import dayjs from 'dayjs';
import { CRLType } from 'shared/types/non-plan-year.types';
import request, { ContentType } from '../api-request';
import { validateDate } from './validateDate';
import queryStringTag from './reportQueryStringTag';

export function download1095CReport(
  companyId: number,
  reportType: CRLType,
  startDate?: string,
  endDate?: string,
) {
  if (companyId <= 0) {
    return Promise.reject(new Error('Cannot download 1095-C data report for invalid company.'));
  }

  try {
    const start = validateDate(
      'Cannot download 1095-C data report for invalid start date.',
      startDate ?? dayjs().format(),
    );
    const end = validateDate(
      'Cannot download 1095-C data report for invalid end date.',
      endDate ?? dayjs().format(),
    );

    const uri =
      queryStringTag`/api/companies/${companyId}/reports/${reportType}/ten95C-data/export${start}${end}`;

    return request(uri, { method: 'GET', headers: { accept: ContentType.XLSX } });
  } catch (err) {
    return Promise.reject(err);
  }
}
